import {
  SET_CAMP_STATE,
  SET_TOTAL_CUSTOMERS,
  RESET_CAMP_STATE,
  SET_CAMP_PERF_OVERVIEW,
  SET_CAMP_LIST,
  SET_CAMP_DETAIL,
  SET_SMS_CREDITS,
  SET_EMAIL_CREDITS,
  SET_CAMP_SHORTLINK,
  INITIALIZE_CAMP_STATE,
  SET_TEST_CAMP_SENT,
  SET_CAMPAIGNS_CUSTOMERS,
  SET_WA_CREDITS,
} from "../types";

const initialState = {
  CampState: {},
  shortlink: "",
  totalCustomers: "",
  creditsRequired: {},
  CampPerformance: {},
  CampList: {},
  CampDetail: [],
  CampCustomers: {},
  isSendTestCamp: false,
};

const campaignsUnpersistedReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMP_STATE:
      return {
        ...state,
        CampState: { ...state.CampState, ...action.payload },
      };
    case INITIALIZE_CAMP_STATE:
      return {
        ...state,
        CampState: action.payload,
      };
    case SET_CAMP_SHORTLINK:
      return {
        ...state,
        shortlink: action.payload,
      };
    case SET_TOTAL_CUSTOMERS:
      return {
        ...state,
        totalCustomers: action.payload,
      };
    case SET_SMS_CREDITS:
      return {
        ...state,
        creditsRequired: { ...state.creditsRequired, sms: action.payload },
      };
    case SET_EMAIL_CREDITS:
      return {
        ...state,
        creditsRequired: { ...state.creditsRequired, email: action.payload },
      };
    case SET_WA_CREDITS:
      return {
        ...state,
        creditsRequired: { ...state.creditsRequired, whatsapp: action.payload },
      };
    case SET_CAMP_PERF_OVERVIEW:
      return {
        ...state,
        CampPerformance: action.payload,
      };
    case SET_CAMP_LIST:
      return {
        ...state,
        CampList: action.payload,
      };
    case SET_CAMP_DETAIL:
      return {
        ...state,
        CampDetail: action.payload,
      };
    case SET_CAMPAIGNS_CUSTOMERS:
      return {
        ...state,
        CampCustomers: action.payload,
      };
    case SET_TEST_CAMP_SENT:
      return {
        ...state,
        isSendTestCamp: action.payload,
      };
    case RESET_CAMP_STATE:
      return initialState;
    default:
      return state;
  }
};

export default campaignsUnpersistedReducer;
